///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthPosition } from '../entities/position';
import { GtthHistoryService } from '../engine/history-service';
import { NgZone } from '@angular/core';

export class GtthInfoOverlayComponent {
    private overlay: any;
    private isMapMoved = false;
    private map: any;

    public createOverlay(position: GtthPosition[], compContainer: any, historyService: GtthHistoryService): google.maps.OverlayView {
        this.map = historyService.map;

        const CustomOverlayClass = class extends google.maps.OverlayView {
            position: GtthPosition;
            compContainer: any;
            container: any;

            constructor(private readonly parentComponent: GtthInfoOverlayComponent) {
                super();
            }

            onAdd(): void {
                this.container = this.parentComponent.createContainer(position);
                this.container.appendChild(this.compContainer);
                this.getPanes().floatPane.appendChild(this.container);
                this.parentComponent.isMapMoved = false;
            }

            onRemove(): void {
                if (this.container.parentElement) {
                    this.container.parentElement.removeChild(this.container);
                }
                this.container = undefined;
            }

            draw(): void {
                if (!this.container) {
                    return;
                }
                const divPosition = this.getProjection().fromLatLngToDivPixel(this.position.toLatLng(google));

                this.container.style.left = divPosition.x + 'px';
                this.container.style.top = divPosition.y + 'px';

                this.parentComponent.mapMoveToWindowView(this.container, historyService.ngZone);
            }

            setPosition(newPosition) {
                this.position = newPosition;
                this.draw();
            }
        };

        this.overlay = new CustomOverlayClass(this);
        this.overlay.position = position[0];
        this.overlay.compContainer = compContainer;
        this.overlay.setMap(this.map);

        return this.overlay;
    }

    private createContainer(position: GtthPosition[]): any {
        const container = document.createElement('div');
        const arrowHtml = '<div class="info-container__arrow"><span class="info-container__arrow__bg"></span></div>';
        const closeInfoBtnHtml = '<span class="info-container__close">×</span>';

        container.insertAdjacentHTML('beforeend', arrowHtml + closeInfoBtnHtml);
        container.classList.add('info-container');

        if (position.length > 1) {
            container.classList.add('info-container--' + this.getInfoWindowDirection(position));
        }

        container.querySelector('.info-container__close').addEventListener('click', (_e) => {
            google.maps.event.trigger(this.overlay, 'closeclick');
        });

        ['click', 'dblclick', 'contextmenu', 'wheel', 'mousedown', 'touchstart', 'pointerdown'].forEach((event) => {
            container.addEventListener(event, (e) => {
                e.stopPropagation();
            });
        });

        return container;
    }

    private getInfoWindowDirection(position: GtthPosition[]): string {
        let direction = '';
        const angle = google.maps.geometry.spherical.computeHeading(position[1].toLatLng(google), position[2].toLatLng(google));
        const verticalDelta = 20;
        const horizontalDelta = 15;
        const isVertical = Math.abs(angle) < verticalDelta || Math.abs(angle) > 180 - verticalDelta;
        const isHorizontal = 90 - horizontalDelta < Math.abs(angle) && Math.abs(angle) < 90 + horizontalDelta;
        if (isHorizontal) {
            direction = 'center';
        } else if (position[1].longitude < position[2].longitude) {
            if (position[1].latitude < position[2].latitude) {
                direction = 'left';
            } else {
                direction = 'right';
            }
        } else if (position[1].longitude > position[2].longitude) {
            if (position[1].latitude > position[2].latitude) {
                direction = 'left';
            } else {
                direction = 'right';
            }
        }

        if (isVertical) {
            direction += '-vertical';
        }

        return direction;
    }

    private mapMoveToWindowView(container: any, ngZone: NgZone) {
        if (this.isMapMoved) {
            return;
        }
        this.isMapMoved = true;
        const divPos = container.getBoundingClientRect();
        const headerHeight = document.querySelector('.header').clientHeight;
        const windowSize = { width: window.innerWidth, height: window.innerHeight };
        const pixelDelta = { x: 0, y: 0 };

        if (divPos.left < 0) {
            pixelDelta.x = divPos.left - 20;
        } else if (divPos.right > windowSize.width) {
            pixelDelta.x = divPos.right - windowSize.width + 20;
        }

        if (divPos.top < headerHeight) {
            pixelDelta.y = divPos.top - headerHeight - 20;
        } else if (divPos.bottom > windowSize.height) {
            pixelDelta.y = divPos.bottom - windowSize.height + 20;
        }

        if (pixelDelta.x === 0 && pixelDelta.y === 0) {
            return;
        }

        ngZone.runOutsideAngular(() => {
            this.map.panBy(pixelDelta.x, pixelDelta.y);
        });
    }
}
